import React, { useEffect, useState } from 'react';
import wideLogo from "../../assets/images/icons/logo.png";
import logo from "../../assets/images/icons/icon.png";
import "./SplashScreen.css";

export default function SplashScreen({ setFirstTime }) {
    const [logoAnimation, setLogoAnimation] = useState('fadeIn');
    const [showWideLogo, setShowWideLogo] = useState(true);

    useEffect(() => {
        // Trigger logo flip-out animation after 2 seconds
        const logoTimeout = setTimeout(() => {
            setLogoAnimation('flipOut');
        }, 2000);

        // Show wide logo after the flip-out animation ends
        const wideLogoTimeout = setTimeout(() => {
            // setShowWideLogo(true);
            // onProceed(); // Call the function to proceed
        }, 3500);

        return () => {
            clearTimeout(logoTimeout);
            clearTimeout(wideLogoTimeout);

        };
    }, []);


    useEffect(() => {
        if (showWideLogo) {
            setTimeout(() => {
                setFirstTime(false)

            }, 2000)
        }
    }, [showWideLogo])
    return (
        <div className="fullPage">
            {/* {!showWideLogo ? <img
                className={`logo ${logoAnimation}`}
                src={logo}
                width="40%"
                alt=""
            /> : */}
            <img
                className="logo flipIn"
                src={wideLogo}
                width="40%"
                alt=""
            />
            {/* } */}
        </div>
    );
}
